import { useFeatureFlagEnabled } from "posthog-js/react";

import { LayoutAppBarV1 } from "./LayoutAppBarV1";
import { LayoutAppBarV2 } from "./LayoutAppBarV2";

export const LAYOUT_APP_BAR_HEIGHT = 60;

export interface LayoutAppBarProps {
  navbarOpened: boolean;
  toggleNavbar: () => void;
}

export const LayoutAppBar = (props: LayoutAppBarProps) => {
  const isThemeV2Enabled = useFeatureFlagEnabled("theme_v2");

  if (isThemeV2Enabled) {
    return <LayoutAppBarV2 {...props} />;
  }

  return <LayoutAppBarV1 {...props} />;
};
